import * as React from 'react'
import { Provider } from 'react-redux'
import { Store } from 'redux'
import { Persistor } from 'redux-persist'
import { PersistGate } from 'redux-persist/lib/integration/react'
import App from '../App'
import Landing from '../pages/Landing'
import StoreService from '../services/store'
import configureStore from './store'

interface IProps {}
interface IState {
  store: Store
  persistor: Persistor
  isLoading: boolean
}
export default class Setup extends React.Component<IProps, IState> {
  notificationListener
  notificationRefreshTokenListener
  constructor(props) {
    super(props)
    const { store, persistor } = configureStore(() =>
      this.setState({ isLoading: false })
    )
    StoreService.setStore(store)
    this.state = {
      isLoading: false,
      store,
      persistor
    }
  }
  render() {
    return (
      <Provider store={this.state.store}>
        <PersistGate
          loading={<Landing alwaysHideContent={true} />}
          persistor={this.state.persistor}
        >
          <App />
        </PersistGate>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/boot/index.tsx